import {NgModule} from '@angular/core';
import {
  MatAutocompleteModule,
  MatBadgeModule,
  MatBottomSheetModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatDividerModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSlider, MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatStepperModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MatTreeModule
} from '@angular/material';
import {CdkStepperModule} from '@angular/cdk/stepper';
import {CdkTableModule} from '@angular/cdk/table';
import {CdkTreeModule} from '@angular/cdk/tree';
import {HighchartsChartModule} from 'highcharts-angular';
import {CamelCasePipe} from './pipes/camel-case.pipe';
import {VarDirective} from './directives/var-directive';
import {DataService} from './services/data.service';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgxSpinnerModule} from 'ngx-spinner';
import {MainNavComponent} from './components/main-nav/main-nav.component';
import {TranslateModule} from '@ngx-translate/core';
import {RouterModule} from '@angular/router';
import {DialogComponent} from './components/dialog/dialog.component';
import {ShowConfigComponent} from '../modules/nanogrid/show-config/show-config.component';


const MODULES = [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    ...[
        MatAutocompleteModule,
        MatBadgeModule,
        MatBottomSheetModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogModule,
        MatDividerModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatGridListModule,
        MatInputModule,
        MatMenuModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatStepperModule,
        MatTableModule,
        MatTabsModule,
        MatTooltipModule,
        MatTreeModule,
        MatSidenavModule,
        MatToolbarModule,
        MatListModule,
        MatIconModule,
      MatSliderModule
    ],
    ...[
        CdkStepperModule,
        CdkTableModule,
        CdkTreeModule
    ],
    ...[
        HighchartsChartModule
    ],
    ...[
        NgxSpinnerModule
    ],
    ...[
        TranslateModule
    ]
];

@NgModule({
    declarations: [
        ...[
            MainNavComponent,
            DialogComponent
        ],
        ...[
            VarDirective
        ],
        ...[
            CamelCasePipe
        ],
        [
            ShowConfigComponent
        ]
    ]
    ,
    exports: [
        ...MODULES,
        ...[
            MainNavComponent,
            DialogComponent
        ],
        ...[
            VarDirective
        ],
        ...[
            CamelCasePipe
        ],
        [
            ShowConfigComponent
        ]
    ],
    imports: [
        ...MODULES
    ],
    providers: [
        DataService
    ],
    entryComponents: [
        DialogComponent
    ]
})
export class SharedModule {
}
